import { Payment } from '@repo-level/core-front';
import { createContext } from 'react';

export interface PaymentMethodContextProps {
  currency: string;
  paymentMethod: Payment.Method;
  currentPrevUsedProfile: Payment.SavedProfile | undefined;
  setCurrentPaymentMethod?: (paymentMethod: Payment.Method) => void;
}

export const PaymentMethodContext = createContext<PaymentMethodContextProps>(
  null as any
);
